export default function Location(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip-location)">
				<path
					d="M16.0029 24L9.9129 15.4C8.91608 14.2231 8.27414 12.7872 8.06185 11.2595C7.84957 9.73183 8.07566 8.17529 8.71381 6.77115C9.35195 5.36702 10.3759 4.17308 11.6664 3.32839C12.9568 2.4837 14.4607 2.02302 16.0029 2C18.1406 2.02113 20.1829 2.88859 21.6823 4.41241C23.1818 5.93623 24.0162 7.99219 24.0029 10.13C24.0037 11.9949 23.3688 13.8044 22.2029 15.26L16.0029 24ZM16.0029 4C14.3948 4.01847 12.8597 4.67438 11.7347 5.82371C10.6098 6.97303 9.9869 8.52183 10.0029 10.13C10.0096 11.5978 10.5377 13.0155 11.4929 14.13L16.0029 20.52L20.6329 14C21.513 12.9014 21.9958 11.5376 22.0029 10.13C22.0189 8.52183 21.396 6.97303 20.2711 5.82371C19.1461 4.67438 17.611 4.01847 16.0029 4Z"
					fill="currentColor"
				/>
				<path
					d="M16 11C17.1046 11 18 10.1046 18 9C18 7.89543 17.1046 7 16 7C14.8954 7 14 7.89543 14 9C14 10.1046 14.8954 11 16 11Z"
					fill="currentColor"
				/>
				<path
					d="M28 12H26V14H28V28H4V14H6V12H4C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14V28C2 28.5304 2.21071 29.0391 2.58579 29.4142C2.96086 29.7893 3.46957 30 4 30H28C28.5304 30 29.0391 29.7893 29.4142 29.4142C29.7893 29.0391 30 28.5304 30 28V14C30 13.4696 29.7893 12.9609 29.4142 12.5858C29.0391 12.2107 28.5304 12 28 12Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip-location">
					<rect width="32" height="32" fill="currentColor" />
				</clipPath>
			</defs>
		</svg>
	)
}
